import Keycloak from 'keycloak-js';

import { inject, Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';

/** Folga usada para renovar o token antes de ele vencer. */
const TOKEN_MIN_VALIDITY_SECONDS = 30;

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {
  private readonly keycloak = inject(Keycloak);

  redirectToLoginPage(): Promise<void> {
    return this.keycloak.login({ redirectUri: environment.keycloak.redirectUri });
  }

  isLoggedIn(): boolean {
    return !!this.keycloak.authenticated;
  }

  getToken(): string | null {
    return this.keycloak.token ?? null;
  }

  async refreshTokenIfNeeded(): Promise<void> {
    // Renova ANTES de expirar. O guard antigo era isTokenExpired() sem folga,
    // entao so entrava aqui com o token ja vencido e a folga de 30s do
    // updateToken nunca valia de nada.
    if (this.isTokenExpired(TOKEN_MIN_VALIDITY_SECONDS)) {
      try {
        await this.keycloak.updateToken(TOKEN_MIN_VALIDITY_SECONDS);
      } catch (error) {
        console.error('Error refreshing token', error);
        throw error;
      }
    }
  }

  logout(): void {
    this.keycloak.logout({ redirectUri: environment.keycloak.postLogoutRedirectUri });
  }

  /**
   * Delega ao keycloak-js porque ele aplica o timeSkew medido no init: contar
   * com Date.now() cru erra nos dois sentidos quando o relogio do cliente esta
   * torto. `minValidity` responde "expira nos proximos N segundos?".
   */
  isTokenExpired(minValidity?: number): boolean {
    try {
      return this.keycloak.isTokenExpired(minValidity);
    } catch {
      // keycloak-js lanca quando nao ha token; sem token, tratamos como expirado.
      return true;
    }
  }
}